export default "__VITE_ASSET__Tkpm5UE1__"